import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProductPreview from "@/components/ProductPreview";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import EnquiryForm from "@/components/EnquiryForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import HeadsetCursor from "@/components/HeadsetCursor";
import Reveal from "@/components/Reveal";
import useSeo from "@/hooks/useSeo";

export default function HomePage() {
  useSeo("Savy Kerno — AI Voice + Marketing Platform", "Savy Kerno — one intelligent platform for AI voice agents, customer relationships and digital marketing. Try the free browser voice demo in English, Hindi or Telugu.");
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#111111] antialiased">
      <HeadsetCursor />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Reveal>
          <ProductPreview />
        </Reveal>
        <Features />
        <Reveal>
          <HowItWorks />
        </Reveal>
        <Reveal>
          <Pricing />
        </Reveal>
        <Reveal>
          <EnquiryForm />
        </Reveal>
        <Reveal>
          <FAQ limit={6} />
        </Reveal>
        <Reveal>
          <div className="border-t border-neutral-100 py-10 text-center">
            <a href="/faq" data-testid="faq-view-all"
              className="text-sm font-semibold text-[#111111] underline underline-offset-4 hover:text-neutral-600">
              View all frequently asked questions →
            </a>
          </div>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
